// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e705aea2","455":"3b1166bb","977":"58e51142"}[chunkId] + ".chunk.js";
};